// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"SectionLRList_TheComp__1lM_B"};